import React, { useState } from 'react';
import './MayWantProduct.css';
import { useStateValue } from './StateProvider';
import CurrencyFormat from 'react-currency-format';
import { Link } from 'react-router-dom';

function MayWantProduct({id, title, price, img}) {
    const [{ basket }, dispatch] = useStateValue();
    var matchcount = 0;

    const addToBasket =() =>{
        // dispatch the item into the data layer
        dispatch({
            type: "ADD_TO_BASKET",
            item:{
                id: id,
                title: title,
                price: price,
                img: img,
                qnt: 1
            },
        });
    }

    const qntBasket =() =>{
        
        basket.map(item =>{

            if(item.id === id){
                item.qnt = item.qnt + 1;
                dispatch({
                    type: "ADD_TO_Qnt",
                    id: id,
                    title: title,
                    price: price,
                    img: img,
                    qnt: item.qnt
                });
            }
            else{
                matchcount += 1
            }
    
        })

        if(basket.length === matchcount){
            matchcount = 0;
            addToBasket()
        }  
    };

    const onDetails =() =>{

        dispatch({
            type: "SET_PRODUCTDETAILS",
            item:{
                id: id,
                title: title,
                price: price,
                img: img,
                qnt: 1
            },
        });

    }

    return (
        <div className="maywantproduct">
            <Link to='/details'><div className="maywantproduct__img" onClick={onDetails}><img src={img} alt="" /></div></Link>
            <h4>{title}</h4>
            <div>
                <CurrencyFormat
                    renderText={(value) => (
                        <>
                            <h3>{value}</h3>
                        </>
                    )}
                    decimalScale={2}
                    value={price}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                />
            </div>
            <div className="maywantproduct__btn"><button onClick={basket.length === 0 ? addToBasket : qntBasket}>add to cart</button></div>
        </div>
    )
}

export default MayWantProduct;
